<template>
  <h1 class="logo">
    <a @click.prevent="() => { $router.push('/').catch(() => {})}"> IAMCOST </a>
  </h1>
</template>

<script>
export default {

}
</script>

<style>

</style>